<form [formGroup]="cmaReportFilterForm">
  <div class="row">
    <div class="col-6 col-md-8 col-12">
      <div class="row">
        <div class="col-md-4 col-12" *ngIf="userRole !== 'investor' && companyAlias != 'valuetest'">
          <mat-form-field class="small-form-field">
            <mat-label>Report Type</mat-label>
            <mat-select formControlName="reportCategory">
              <mat-option *ngFor="let report of reportTypes" [value]="report.value">
                {{ report.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-12">
          <mat-form-field class="small-form-field">
            <mat-label> Search By Address</mat-label>
            <input matInput autocomplete="off" placeholder="Search Address" formControlName="searchAddress" />
          </mat-form-field>
        </div>
        <div class="col-md-4 col-12">
          <button mat-flat-button color="primary" class="primary mr-2" (click)="filterBtn()">Filter</button>
          <button mat-stroked-button class="primary" (click)="resetReportsFilter()">Reset</button>
        </div>
      </div>
    </div>

    <div
      class="col-12 col-md-4"
      *ngIf="
        (userRole == 'agent' || userRole == 'loanOfficer' || userRole == 'companyManager') &&
        companyAlias != 'valuetest'
      "
    >
      <div class="float-right ml-3">
        <mat-checkbox color="primary" (change)="coBrandedWithMe()" [checked]="isCoBrandedByMe"
          >Display All Reports</mat-checkbox
        >
        <mat-icon
          class="float-right disclaimer"
          matTooltip="Reports created by your clients and shared by your partner"
          matTooltipPosition="below"
          >error_outline</mat-icon
        >
      </div>
    </div>
    <div class="col-12 col-md-4" *ngIf="userRole == 'companyManager' && companyAlias == 'valuetest'">
      <div class="float-right ml-3">
        <mat-checkbox color="primary" class="float-right" (change)="coBrandedWithMe()" [checked]="!isCoBrandedByMe"
          >Created By Me</mat-checkbox
        >
      </div>
    </div>
  </div>
</form>
<!-- <form [formGroup]="cmaReportFilterForm">
  <div class="row">
    <div class="col-6 col-md-2" *ngIf="userRole !== 'investor' && companyAlias != 'valuetest'">
      <mat-form-field class="small-form-field">
        <mat-label>Report Type</mat-label>
        <mat-select formControlName="reportCategory">
          <mat-option *ngFor="let report of reportTypes" [value]="report.value">
            {{ report.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-6 col-md-2">
      <mat-form-field class="small-form-field">
        <mat-label> Search By Address</mat-label>
        <input matInput autocomplete="off" placeholder="Search Address" formControlName="searchAddress" />
      </mat-form-field>
    </div>

    <div class="col-12 col-md-2 mb-3">
      <button mat-flat-button color="primary" class="primary mr-2" (click)="filterBtn()">Filter</button>
      <button mat-stroked-button class="primary" (click)="resetReportsFilter()">Reset</button>
    </div>

    <div class="col-12 col-md-4">
      <div
        class="float-right ml-3"
        *ngIf="
          (userRole == 'agent' || userRole == 'loanOfficer' || userRole == 'companyManager') &&
          companyAlias != 'valuetest'
        "
      >
        <mat-checkbox color="primary" class="float-right" (change)="coBrandedWithMe()" [checked]="isCoBrandedByMe"
          >Other Reports</mat-checkbox
        >
      </div>
    </div>
    <div class="col-12 col-md-4" *ngIf="userRole == 'companyManager' && companyAlias == 'valuetest'">
      <div class="float-right ml-3">
        <mat-checkbox color="primary" class="float-right" (change)="coBrandedWithMe()" [checked]="!isCoBrandedByMe"
          >Created By Me</mat-checkbox
        >
      </div>
    </div>
  </div>
</form> -->
<!-- <div class="col-6 col-md-2">
      <mat-form-field class="small-form-field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">
            {{ status.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
